// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { iconOffset } from "@hardwoods/XDL/PreStyle/formField";
import { xBaseTheme } from "@hardwoods/XDL/types";
import color from "@hardwoods/XDL/Utilities/color";
import { css } from "styled-components";

export default {
    defaultProps: {
        iconProps: {
            src: "ChevronDown",
            css: css`
                color: ${color("text.secondary")};
                position: absolute;
                right: 0;
                bottom: 10px;
            `,
        },
        cssOverrides: {
            selectedText: css`
                padding: 5px ${iconOffset}px 5px 10px;
                text-overflow: ellipsis;
                top: 50%;
                transform: translateY(-50%);
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
